import buildWorkbook from "./buildWorkbook";
import downloadWorkbook from "./downloadWorkbook";
import type { WorkbookSpec } from "./types";

export default async function exportWorkbook(spec: WorkbookSpec) {
    const workbook = await buildWorkbook(spec);

    await downloadWorkbook(workbook, spec.fileName);
}
